const MainWindow = () => {
  return <div>MainWindow</div>;
};

export default MainWindow;
